<script lang="ts" setup>
const { getListAttributes } = useApiAttributes()
const { t } = useI18n()

const endpoints: ApiEndpoint[] = [
  {
    method: 'POST',
    path: '/lists',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.dynamic'),
    name: 'dynamic',
    optional: true,
    type: 'boolean',
    values: ['false', 'true'],
  },
  {
    description: t('attributes.name'),
    name: 'name',
    required: true,
    type: 'string',
  },
  {
    description: t('attributes.type'),
    name: 'type',
    required: true,
    type: 'string',
    values: ['companies'],
  },
]

const responseAttributes = getListAttributes()

const response = {
  analytics: { companiesCount: 0 },
  createdAt: '2022-04-01T13:07:14.000+00:00',
  dynamic: false,
  id: 4246,
  imported: false,
  integrations: [],
  name: 'SaaS with 100k+ MRR',
  processActive: false,
  processingAt: '2022-04-01T13:07:15.000+00:00',
  processInitialized: true,
  query: [],
}
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :level-to-open="0"
    :query-attributes="queryAttributes"
    :response="response"
    :response-attributes="responseAttributes"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "dynamic": "If the list is dynamic. When set to true, the list will be updated automatically when new companies are added to the database.",
      "name": "The name of the list.",
      "type": "The type of list to create."
    }
  },
  "es": {
    "attributes": {
      "dynamic": "Si la lista es dinámica o no. Si se establece en true, la lista se actualizará automáticamente cuando se agreguen nuevas empresas a la base de datos.",
      "name": "El nombre de la lista.",
      "type": "El tipo de lista a crear."
    }
  },
  "fr": {
    "attributes": {
      "dynamic": "Si la liste est dynamique ou non. Si défini à true, la liste sera mise à jour automatiquement lorsque de nouvelles entreprises seront ajoutés à la base de données.",
      "name": "Le nom de la liste.",
      "type": "Le type de liste à créer."
    }
  }
}
</i18n>
